export const LOOP_REQ_TYPES = {
  BATCH_ADDITION: 1,
  BATCH_UPDATION: 2,
  MENTOR_INITIATION: 3,
  STUDENT_INITIATION: 4,
};
